import { capitalize } from "lodash";
import { MenuItem, MenuItems } from "../../../../components/@types";
import { TimeEnum } from "../../../../lib/enums";
import { CLASSIFICATION_KEYWORDS } from "../../consts";
import {
  ATTACK_TECHNIQUE_SUGGESTIONS,
  TAGS_LIST,
  TC_INDICATORS
} from "../../mappings";
import { FILE_TYPES_LIST } from "../../mappings/file_types";
import { AV_VENDORS } from "./consts";
import { FileSearchMenuItem } from "./files/@types";

export const getTimeRangeMenuItems = (
  allMenuItem: MenuItem,
  customDateMenuItem: MenuItem
) => [
  {
    label: "Select time range",
    value: ""
  },
  allMenuItem,
  customDateMenuItem,
  {
    label: "Today",
    value: TimeEnum.TODAY
  },
  {
    label: "Last Week",
    value: TimeEnum.LAST_WEEK
  },
  {
    label: "Last Month",
    value: TimeEnum.LAST_MONTH
  },
  {
    label: "Last 3 Months",
    value: TimeEnum.LAST_QUARTER
  },
  {
    label: "Last Year",
    value: TimeEnum.LAST_YEAR
  }
];

const FILE_NAME_OPTIONS = {
  CONTAINS: "Contains",
  MATCHES_EXACTLY: "Matches Exactly",
  STARTS_WITH: "Starts With",
  ENDS_WITH: "Ends With"
};

export const getFileNameOptionsMenuItems: () => MenuItems = () =>
  Object.entries(FILE_NAME_OPTIONS).map(([key, value]) => ({
    label: value,
    value: key
  }));

export const getFileTypeMenuItems: () => MenuItems = () =>
  FILE_TYPES_LIST.map(value => ({
    value,
    label: value
  }));

export const getFileTagsMenuItems: () => MenuItems = () =>
  TAGS_LIST.map(value => ({
    value,
    label: value
  }));

export const getClassificationMenuItems: () => MenuItems = () =>
  Object.values(CLASSIFICATION_KEYWORDS).map(value => ({
    label:
      value === CLASSIFICATION_KEYWORDS.UNKNOWN
        ? "Unknown (No Threats Found)"
        : capitalize(value),
    value
  }));

export const getAttackTechniqueMenuItems: () => MenuItems = () =>
  ATTACK_TECHNIQUE_SUGGESTIONS.map(value => ({
    value: value.value,
    label: value.name
  }));

export const getTcIndicatorMenuItems: () => FileSearchMenuItem[] = () =>
  TC_INDICATORS.map((value: { name: string; value: string }) => ({
    listValue: value.value.split(","),
    value: value.value,
    label: value.name
  }));

export const getAvVendorsMenuItems: () => MenuItems = () =>
  Object.entries(AV_VENDORS).map(([key, value]) => ({
    label: key,
    value
  }));

export const getResourceTypeMenuItems = (): MenuItems => [
  {
    value: "all",
    label: "All"
  },
  {
    value: "url",
    label: "URL"
  },
  {
    value: "domain",
    label: "Domain"
  },
  {
    value: "ip",
    label: "IP"
  }
];
